import axios from 'axios';
import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';

const useFeatureFlagsStore = create(
  subscribeWithSelector((set, get) => ({
    // State
    features: [],
    isLoading: false,
    isLoaded: false,
    error: null,

    // Actions
    setFeatures: (features) => set({ features }),
    
    setLoading: (isLoading) => set({ isLoading }),
    
    setLoaded: (isLoaded) => set({ isLoaded }),
    
    setError: (error) => set({ error }),

    // Load feature flags for the current user
    loadFeatureFlags: async () => {
      const { isLoading } = get();
      
      if (isLoading) {
        return;
      }

      set({ isLoading: true, error: null });

      try {
        const response = await axios.get('/auth/feature-flags');
        const { features } = response.data.data;
        
        set({ 
          features, 
          isLoading: false, 
          isLoaded: true,
          error: null 
        });
      } catch (error) {
        console.error('Failed to load feature flags:', error);
        set({ 
          error: error.response?.data?.error || 'Failed to load feature flags',
          isLoading: false,
          isLoaded: false
        });
      }
    },

    // Check if a feature flag is enabled
    isFeatureEnabled: (featureKey) => {
      const { features } = get();
      const feature = features.find(f => f.featureKey === featureKey);
      return feature?.enabled || false;
    },

    // Get a feature flag by key
    getFeature: (featureKey) => {
      const { features } = get();
      return features.find(f => f.featureKey === featureKey) || null;
    },

    // Get all enabled features
    getEnabledFeatures: () => {
      const { features } = get();
      return features.filter(f => f.enabled);
    },

    // Reset store (useful for logout)
    reset: () => set({
      features: [],
      isLoading: false,
      isLoaded: false,
      error: null
    }),

    // Clear error
    clearError: () => set({ error: null }),
  }))
);

export default useFeatureFlagsStore;
